import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledOption = styled(InnerComponent).attrs({ Component: components.Option })`
  && {
    border-bottom: 1px solid ${colors.secondary95};
    color: ${colors.secondary40};
    cursor: pointer;
    white-space: nowrap;
    padding: 8px;
    min-height: 30px;

    &.react-select__option--is-selected {
      color: ${colors.secondary20};
      background-color: ${colors.primary80};
    }

    /* both for hovered and focused */
    &&.react-select__option--is-focused {
      color: ${colors.secondary20};
      background-color: ${colors.primary90};
    }
  }
`

const OptionWithIcon = styled.div`
  display: flex;
  align-items: center;
  line-height: 14px;
  gap: 4px;
}`

const Option = props => {
  const { iconComponentsMap } = props.selectProps

  if (!iconComponentsMap) {
    return <StyledOption {...props} />
  }

  const OptionComponent = () => iconComponentsMap[props.data.value] || null

  return (
    <StyledOption {...props}>
      <OptionWithIcon>
        <OptionComponent />
        {props.data.label}
      </OptionWithIcon>
    </StyledOption>
  )
}

Option.propTypes = {
  selectProps: PropTypes.object,
  data: PropTypes.object,
}

export default Option
